<script>
export default {
  computed: {
    mappedXAxisTicks() {
      if (this.data.length > 0) {
        // the xAxis ticks are the min value from each bucket
        const newTicks = this.data.map(dataObj => {
          if (this.alertType === 'acmf') {
            return `${+dataObj.min.toFixed(2)}`
          } else {
            return `${+dataObj.value.toFixed(2)}`
          }
        })
        if (this.alertType === 'acmf') {
          newTicks.push(this.data[this.data.length - 1].max.toString())
        }
        return newTicks
      } else {
        return []
      }
    },
    minXAxisTick() {
      return Math.min.apply(null, this.mappedXAxisTicks)
    },
    maxXAxisTick() {
      return Math.max.apply(null, this.mappedXAxisTicks)
    },
  },
}
</script>
